// extracted by mini-css-extract-plugin
module.exports = {"personList":"PersonList_personList__jFmj6"};